import { atom } from "nanostores";

const KEY = "nomen.fps";

/** Whether the frame-rate readout shows: ?fps=1 for this visit, or the settings switch remembered on this device. */
export const $showFps = atom(false);

export function initShowFps(search: string): void {
  if (new URLSearchParams(search).has("fps")) { $showFps.set(true); return; }
  try { $showFps.set(localStorage.getItem(KEY) === "1"); } catch { $showFps.set(false); }
}

export function setShowFps(on: boolean): void {
  $showFps.set(on);
  try { if (on) localStorage.setItem(KEY, "1"); else localStorage.removeItem(KEY); } catch { /* blocked storage: this visit only */ }
}
